import OBase from './OBase';

import * as Geometry from '../geometry';

export default class Round extends OBase {
  update () {
    let valTree = this.getFloatInput('Number');
    let nOutput = this.getGenericObjectOutput('Nearest');
    let fOutput = this.getGenericObjectOutput('Floor');
    let cOutput = this.getGenericObjectOutput('Ceiling');

    var nOutTree = new Geometry.DataTree();
    var fOutTree = new Geometry.DataTree();
    var cOutTree = new Geometry.DataTree();

    for (let i = 0; i < valTree.branches.length; i++) {
      for (let j = 0; j < valTree.branches[i].length; j++) {
        let val = valTree.branches[i][j];
        let nval = Math.round(val);
        let fval = Math.floor(val);
        let cval = Math.ceil(val);

        nOutTree.add(nval, valTree.paths[i]);
        fOutTree.add(fval, valTree.paths[i]);
        cOutTree.add(cval, valTree.paths[i]);
      }
    }

    nOutput.value = nOutTree;
    fOutput.value = fOutTree;
    cOutput.value = cOutTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Round.js